import { Tool } from '../../types';

export const salesTools: Tool[] = [
  {
    id: 'salesforce',
    name: 'Salesforce',
    category: 'Sales & CRM',
    description: 'The world\'s leading CRM platform for enterprise sales management. Track leads, manage pipelines, forecast revenue, and automate workflows at scale. Extensive app ecosystem with AI-powered insights through Einstein Analytics.',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['saas', 'service-business', 'consulting-firm'],
    goals: ['increase-sales', 'improve-marketing', 'enhance-customer-service'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://www.salesforce.com',
    imageUrl: 'https://logo.clearbit.com/salesforce.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'small'
  },
  {
    id: 'pipedrive',
    name: 'Pipedrive',
    category: 'Sales & CRM',
    description: 'Sales-focused CRM designed by salespeople for salespeople. Visual pipeline management, activity tracking, email integration, and smart automation help you close more deals. Simple setup with powerful customization options.',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['increase-sales', 'streamline-operations'],
    industries: ['consulting', 'marketing', 'technology'],
    website: 'https://aff.trypipedrive.com/8vir3qqmj715',
    imageUrl: 'https://logo.clearbit.com/pipedrive.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    category: 'Sales & CRM',
    description: 'Complete growth platform combining CRM, marketing, sales, and service tools. Free forever CRM core with powerful paid add-ons. Inbound marketing pioneer with excellent content management and lead nurturing capabilities.',
    pricing: ['free', 'medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'service-business', 'agency'],
    goals: ['increase-sales', 'improve-marketing', 'enhance-customer-service'],
    industries: ['technology', 'marketing', 'consulting'],
    website: 'https://www.hubspot.com',
    imageUrl: 'https://logo.clearbit.com/hubspot.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];